module.exports = __webpack_public_path__ + "img/collar-cm.37341695.svg";